import type { CheckoutOrderQuery_magento2_customer_globalOrders_items_items as OrderItem } from '../__generated__/CheckoutOrderQuery';

export enum SerialSystemGroup {
  IZOTOPE = 'IZO_DB',
  NATIVE = 'SDBS',
  COMBINED = 'COMBINED',
}

export const getSerialSystemGroup = (
  orderItems: OrderItem[],
): SerialSystemGroup => {
  const isOnlyItozope = (item) =>
    item.productSerialSystem === SerialSystemGroup.IZOTOPE;
  const isOnlyNative = (item) =>
    item.productSerialSystem === SerialSystemGroup.NATIVE;

  if (orderItems?.every(isOnlyItozope)) return SerialSystemGroup.IZOTOPE;
  if (orderItems?.every(isOnlyNative)) return SerialSystemGroup.NATIVE;

  return SerialSystemGroup.COMBINED;
};
